// ============================================================================
// ENGLISH TRANSLATIONS - BIBLE FACTS
// ============================================================================
// Interesting biblical facts

export const bibleFacts = [
  {
    category: "statistics",
    text: "The Bible contains 31,173 verses in total",
    source: "Textual analysis of manuscripts"
  },
  {
    category: "languages",
    text: "The Bible has been translated into more than 3,000 different languages",
    source: "United Bible Societies"
  },
  {
    category: "composition",
    text: "The Bible was written over about 1,600 years by 40 different authors",
    source: "Biblical historical studies"
  },
  {
    category: "structure",
    text: "Psalm 119 is the longest chapter with 176 verses",
    source: "Canonical structure"
  },
  {
    category: "records",
    text: "The shortest verse in English is 'Jesus wept' (John 11:35)",
    source: "Textual analysis"
  },
  {
    category: "symbolism",
    text: "The number 7 symbolizes perfection and appears 735 times",
    source: "Biblical numerical studies"
  },
  {
    category: "vocabulary",
    text: "The word 'love' in various forms appears more than 500 times",
    source: "Biblical concordance"
  }
];

export default bibleFacts;